import formatCurrency from 'syf-js-utilities/formats/formatCurrency';
import { isInstallmentLoan, isSecuredInstallmentLoanProduct } from '../../helpers';
import { t } from '../../strings/i18n';
import { requiredIf } from '../../xform';
const validateOtherAmount = (accountSummary, helpNumber) => {
    const { credit, product } = accountSummary;
    const { currentBalance } = credit;
    const isSecuredInstallmentLoan = isSecuredInstallmentLoanProduct(product.type);
    const isInstallmentLoanProduct = isInstallmentLoan(product.type);
    return (otherAmountInputValue, values) => {
        const otherAmountInputValueInNumber = Number(otherAmountInputValue);
        const currentBalanceInNumber = Number(currentBalance);
        if (otherAmountInputValue === null ||
            otherAmountInputValue === undefined ||
            otherAmountInputValue === '') {
            return;
        }
        if (values.paymentOption !== 'otherAmountOption') {
            return;
        }
        if (otherAmountInputValueInNumber === 0) {
            throw new Error(t('errors.otherAmountZeroError'));
        }
        if (isSecuredInstallmentLoan &&
            otherAmountInputValueInNumber >= currentBalanceInNumber) {
            throw new Error(t('errors.otherAmountGreaterThanEqualToLoanBalance', { helpNumber }));
        }
        if (isInstallmentLoanProduct &&
            otherAmountInputValueInNumber === currentBalanceInNumber) {
            throw new Error(t('errors.otherAmountPayOffError'));
        }
        if (isInstallmentLoanProduct &&
            otherAmountInputValueInNumber > currentBalanceInNumber) {
            throw new Error(t('errors.otherAmountGreaterThanLoanBalance', {
                statementBalance: formatCurrency(currentBalance)
            }));
        }
        if (otherAmountInputValueInNumber > currentBalanceInNumber) {
            throw new Error(t('errors.amountGreaterThanCurrentBalance'));
        }
    };
};
export const PAYMENT_AMOUNT_INPUT_NAME = 'paymentAmount';
const paymentAmountConfig = (apiMachineRef) => {
    const api = apiMachineRef.getSnapshot().context;
    const accountSummary = api.accountSummaryQueryResult.data;
    const { helpNumber } = api;
    return [
        PAYMENT_AMOUNT_INPUT_NAME,
        undefined,
        'ENABLED',
        [
            requiredIf(t('errors.otherAmount'), ({ paymentOption }) => paymentOption === 'otherAmountOption'),
            validateOtherAmount(accountSummary, helpNumber)
        ]
    ];
};
export default paymentAmountConfig;
